<template>
    <div class="title">
        <h1>第一届Another杯国庆拆塔大赛</h1>
        <div class="rostrum">
            <div class="mask-left"></div>
            <div class="mask-right"></div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.title {
    margin-bottom: 150px;
    h1 {
        position: relative;
        top: 50px;
    }
}
.rostrum {
    position: relative;
    height: 100px;
    width: 300px;
    background: linear-gradient(45deg, black, transparent);
    margin: auto;
    bottom: -120px;
    .mask-left, .mask-right {
        position: absolute;
        width: 100px;
        background: white;
    }
    .mask-left {
        height: 35px;
        top: 0;
        left: 0;
    }
    .mask-right {
        height: 60px;
        top: 0;
        right: 0;
    }
}
</style>